import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-[486px] w-[769px] relative" }
const _hoisted_2 = { class: "pl-[120px]" }
const _hoisted_3 = { class: "mt-[43px] h-[443px] w-[649px] relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-[363px] w-[469px] bg-[var(--primary-color)]" }, null, -1)
const _hoisted_5 = { class: "absolute top-[50%] right-0 translate-y-[-50%]" }
const _hoisted_6 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'Photo',
  props: {
    excursion: {}
  },
  setup(__props: any) {



const strapiUrl = process.env.VUE_APP_STRAPI_URL;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: `${_unref(strapiUrl)}${_ctx.excursion?.data.attributes.img.data.attributes.url}`,
            class: "w-[585px] h-[363px] object-cover"
          }, null, 8, _hoisted_6)
        ])
      ])
    ])
  ]))
}
}

})